module.exports = __webpack_public_path__ + "img/image.ae0f0996.jpeg";